module.exports = new __parcel__URL__("whale01.7d6e7a57.wav").toString();